export const getHeaders = (xFingerprint = null, access_token = null) => {
  const headers = { 'Content-Type': 'application/json' };
  if (xFingerprint && xFingerprint !== 'null')
    headers['X-FINGERPRINT'] = xFingerprint;
  if (access_token && access_token !== 'null')
    headers.Authorization = 'Bearer ' + access_token;

  return headers;
};
